/* eslint-disable react/jsx-no-useless-fragment */
import { lazy } from "react";
import { FormProvider, useForm } from "react-hook-form";
import Skeleton from "react-loading-skeleton";

// Components
import GameSortAndFilter from "components/organisms/GameSortAndFilter";
import CarouselBannersDesktop from "components/molecules/CarouselBannersDesktop";
import GameFormSearch from "components/molecules/GameFormSearch";
import SkeletonSearchFilterDesktop from "components/molecules/SkeletonSearchFilterDesktop";

// Containers
import GameListContainer from "containers/organisms/GameListContainer";
import GameSortDesktopContainer from "containers/organisms/GameSortDesktopContainer";
import GameSearchListContainer from "containers/molecules/GameSearchListContainer";
import BonusWidgetContainer from "containers/molecules/BonusWidgetContainer";

// Hooks
import useTranslate from "hooks/useTranslate";
import { useBreakpoint } from "hooks/useBreakpoint";
import { useLoaderStore } from "stores/loader";

// Types
import { CategoryType } from "redux/game/slice";

import "./styles.sass";
import SEOH1 from "utils/helmet/components/SEOH1";
import { useLocation } from "react-router-dom";
import url from "url/index";
import { useSelector } from "react-redux";
import * as userSelectors from "../../../../redux/user/selectors";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { getEnv } from "../../../../utils/hostname";

const LazyMiniIframe = lazy(() => import("components/organisms/GR8MiniIFrame"));

type HomePageProps = {
  category: CategoryType | null;
};
const isDev = getEnv() === "dev" || getEnv() === "local";

const HomePage = (props: HomePageProps) => {
  const { category } = props;
  const userData = useSelector(userSelectors.all);

  const methods = useForm();

  const location = useLocation();

  const { overlayLoading } = useLoaderStore();

  const { isDesktop } = useBreakpoint();
  const t = useTranslate();
  /* eslint-disable-next-line no-nested-ternary */
  const categoryTitle = location.pathname.includes(url.config.casino.live)
    ? "casino.top.livecasino"
    : category
      ? category.title
      : "";

  const searchQuery = methods.watch("search");
  return (
    <>
      <CarouselBannersDesktop />
      {!useFeatureFlag("games_betting_gr8", `${userData?.id}`) && isDev && (
        <LazyMiniIframe />
      )}

      {isDesktop && <BonusWidgetContainer />}
      <FormProvider {...methods}>
        <div className="HomePage">
          <div className="HomePage__header">
            {!isDesktop && <GameSortAndFilter />}
            {isDesktop && (
              <>
                {overlayLoading ? (
                  <SkeletonSearchFilterDesktop />
                ) : (
                  <>
                    <GameFormSearch />
                    <GameSortDesktopContainer />
                  </>
                )}
              </>
            )}
          </div>
          <div className="HomePage__title">
            {overlayLoading ? (
              <Skeleton width={206} height={26} />
            ) : (
              <SEOH1
                title={t(
                  searchQuery && searchQuery.length > 0
                    ? "casino.search.title"
                    : categoryTitle,
                )}
              />
            )}
          </div>
          <div className="HomePage__games">
            {searchQuery && searchQuery.length > 0 ? (
              <GameSearchListContainer />
            ) : (
              <GameListContainer />
            )}
          </div>
        </div>
      </FormProvider>
    </>
  );
};

export default HomePage;
